module.exports = __webpack_public_path__ + "fb01b114ea1290d1cdae3178ccff57c6.svg";